import React from "react";
import { Link } from "react-router-dom";

const FooterHome: React.FC = () => {
  const footer_icons = ["ed2d.png", "access.png", "lock.png"];
  const footer_alts = ["Ed law 2 d compliant icon", "ADA compliant icon", ""];
  return (
    <footer className="hidden-print footer_home">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 logos">
            <ul className="list-unstyled d-inline-flex">
              {footer_icons.map((icon, index) => (
                <li key={`key_${icon}`} className="mr-2">
                  <img
                    src={`${process.env.REACT_APP_CDN_IMG}${icon}`}
                    alt={footer_alts[index]}
                    className="fb_footer mb-2"
                  />
                </li>
              ))}
            </ul>
            <p>
              We're proud to have an accessible website. Flangoo is COPPA,
              FERPA, ED 2-D, <br /> and ADA compliant, and protected by Cyber
              Insurance Security.
            </p>
            <div className="">
              <a
                href="https://www.facebook.com/Go2Flangoo/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={`${process.env.REACT_APP_CDN_IMG}facebook_nav.png`}
                  alt="Facebook"
                  className="fb_footer"
                />
              </a>
              <a
                href="https://www.teachersdiscovery.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/TD-Voces-Logo-Stacked-WhiteBackground.png"
                  alt="Teacher's Discovery"
                  className="img-fluid"
                />
              </a>
            </div>
          </div>
          <div className="col-lg-12">
            <h2>Helpful Links</h2>
            <ul className="list-unstyled columns">
              <li>
                <Link to="/titles">Included Titles</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/contact">Get a Quote</Link>
              </li>
              <li>
                <a
                  href="https://www.teachersdiscovery.com/downloads/W9.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download W-9{" "}
                </a>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/support">Support</Link>
              </li>
              <li>
                <Link to="/general/privacypolicy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/general/refundpolicy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/contact">Get a Live-Person Guided Walkthrough</Link>
              </li>
              <li>
                <Link to="/about">About Flangoo</Link>
              </li>
              <li>
                <a
                  target={"_blank"}
                  rel="noreferrer"
                  href={
                    process.env.REACT_AUTHORS_URL ||
                    "https://creator.flangoo.com"
                  }
                >
                  Become a Creator{" "}
                  <span aria-hidden="true">
                    <i className="fas fa-pen-alt text-white"></i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-12 mt-3">
            <p>
              Copyright © 2005-{new Date().getFullYear()} Teacher's Discovery®,
              a division of American Eagle Co., Inc. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterHome;
